import React from "react";
import { Lock } from "lucide-react";

import Layout from "src/components/layout/dashboard/Layout";
import Card from "src/components/common/card/Card";
import ResetPasswordCard from "src/components/cards/ResetPasswordCard";

const SettingsPasswordPage: React.FC = () => {
  return (
    <Layout
      type="admin"
      meta={{
        title: "Password | Invyntra Admin",
        description: "Change your account password.",
        keywords: "password, security, settings, invyntra",
      }}
    >
      <div className="mx-auto max-w-3xl space-y-4">
        <div className="flex items-start gap-4">
          <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-primary-100 text-primary-600 dark:bg-primary-900/40 dark:text-primary-300">
            <Lock size={26} />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
              Password
            </h1>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Update the password you use to sign in.
            </p>
          </div>
        </div>

        <Card>
          <ResetPasswordCard variant="admin" />
        </Card>
      </div>
    </Layout>
  );
};

export default SettingsPasswordPage;
